import React from 'react';

import { css } from '@emotion/css';
import { Typography, TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SUPPORT_EMAIL, SUPPORT_PHONE } from '@/AppConstants.ts';
import { useStyles } from '@/hooks/useStyles.ts';

export type ContactSupportProps = TypographyProps;

export const ContactSupport: React.FC<ContactSupportProps> = props => {
  const { t } = useTranslation();
  return (
    <Typography component="span" {...props}>
      {`${t('support.contactUs')} `}
      <ContactSupportInfo />
    </Typography>
  );
};

export const ContactSupportInfo: React.FC<ContactSupportProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Typography className={className}>
      {`${t('support.byEmail')} `}
      <Typography
        component="a"
        href={`mailto:${SUPPORT_EMAIL.value}`}
        className={styles.link}
      >
        {SUPPORT_EMAIL.label}
      </Typography>
      {` ${t('support.or')} ${t('support.byPhone')} `}
      <Typography
        component="a"
        href={`tel:${SUPPORT_PHONE.value}`}
        className={styles.link}
      >
        {SUPPORT_PHONE.label}
      </Typography>
    </Typography>
  );
};

const makeStyles = () => ({
  link: css({
    color: 'inherit',
    cursor: 'pointer',
  }),
});
